const works = [
  {
    title: "01. Learn Nigerian Law",
    link: "https://www.learnnigerianlaw.com/",
    description:
      "I built a website with comprehensive notes on the Nigerian law. I worked with <a href='https://mirrorfisayo.vzy.io/' target='_blank' rel='noopener noreferrer' class='referrals'>Fisayo</a> and <a href='https://gabrielabubakar.netlify.app/' target='_blank' rel='noopener noreferrer' class='referrals'>Gabriel</a>. My role involved project/product management and frontend development. The site sees 16k unique monthly users.",
  },
];

export default works;
